var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{attrs:{"id":"app"}},[_c('itr-header',{attrs:{"statusshow":_vm.statusShow,"statustype":_vm.jobType,"statuspercent":_vm.jobPercent}}),_c('main',[_c('router-view')],1),_c('itr-footer'),_c('vue-snotify')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }